import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninRedirectCallbackComponent } from '@modules/auth/callbacks/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from '@modules/auth/callbacks/signout-redirect-callback.component';
import { UnauthorizedComponent } from '@modules/auth/components';
import { PlatformAccessGuard } from '@modules/dashboard/guards';
import { PLATFORM_ROUTE_ACCESS } from '@modules/navigation/constants/platform-access-policy.constants';
import { ROUTE_ROOTS } from '@modules/navigation/models';
import { AuthGuard } from './core/auth-guard';
import {
    ReconciliationManagerRoutingModule
} from '@modules/reconciliation-manager/reconciliation-manager-routing.module';

const authenticatedGuards = [AuthGuard];
const platformAccessGuards = [AuthGuard, PlatformAccessGuard];

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        // redirectTo: '/invoicemgt/invoiceview',
        // redirectTo: '/supplierportal/invoiceupload',
        // redirectTo: '/auth/login'
         redirectTo: `/${ROUTE_ROOTS.PLATFORM}`
    },
    { path: 'signin-callback', component: SigninRedirectCallbackComponent },
    { path: 'signout-callback', component: SignoutRedirectCallbackComponent },
    { path: 'unauthorized', component: UnauthorizedComponent },
    {
        path: 'auth',
        loadChildren: () =>
            import('modules/auth/auth-routing.module').then((m) => m.AuthRoutingModule),
    },
    {
        path: 'supplierportal',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () => import('modules/invoice-uploader/invoice-uploader-routing.module').then(m => m.InvoiceUploaderRoutingModule),
    },
    {
        path: 'invoicemgt',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () => import('modules/invoice-management/invoice-management-routing.module').then(m => m.InvoiceManagementRoutingModule),
    },
    {
        path: 'historyupload',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () => import('modules/history-upload/history-upload-routing.module').then(m => m.HistoryUploadRoutingModule),
    },
    {
        path: 'documentregister',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        title: 'Document Register Result',
        loadChildren: () => import('modules/registered-document-manager/registered-document-manager-routing.module').then(m => m.RegisteredDocumentManagerRoutingModule),
    },
    {
      path: 'documentregister/:docId',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
      title: 'Document Register Result',
      // component: DocumentRegisterResultPageComponent,
        loadChildren: () => import('modules/registered-document-manager/registered-document-manager-routing.module').then(m => m.RegisteredDocumentManagerRoutingModule),
    },
    {
        path: 'charts',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () =>
            import('modules/charts/charts-routing.module').then((m) => m.ChartsRoutingModule),
    },
    // {
    //     path: 'dashboard',
    //     // canActivate: [AuthGuard],
    //     loadChildren: () =>
    //         import('modules/dashboard/dashboard-routing.module').then(
    //             (m) => m.DashboardRoutingModule
    //         ),
    // },
    {
        path: ROUTE_ROOTS.PLATFORM,
        canActivate: authenticatedGuards,
        canMatch: authenticatedGuards,
        loadChildren: () =>
            import('modules/dashboard/dashboard-routing.module').then(
                (m) => m.DashboardRoutingModule
            ),
    },
    {
        path: ROUTE_ROOTS.USER_WORKSPACE,
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.INDIVIDUAL_ONLY },
        loadChildren: () =>
            import('@modules/workspace/workspace-routing.module').then(
                (m) => m.WorkspaceRoutingModule
            ),
    },
    {
        path: 'reconcilation-manager',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () => import('modules/reconciliation-manager/reconciliation-manager-routing.module').then(m => m.ReconciliationManagerRoutingModule),
    },
    {
        path: 'account',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () =>
            import('modules/account/account-routing.module').then((m) => m.AccountRoutingModule),
    },
    {
        path: '404',
        loadChildren: () =>
            import('modules/error/error-routing.module').then((m) => m.ErrorRoutingModule),
    },
    {
        path: 'error',
        canActivate: authenticatedGuards,
        canMatch: authenticatedGuards,
        loadChildren: () =>
            import('modules/error/error-routing.module').then((m) => m.ErrorRoutingModule),
    },
    {
        path: 'knowledge-base',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () =>
            import('modules/knowledge-base/knowledge-base-routing.module').then(
                (m) => m.KnowledgeBaseRoutingModule
            ),
    },
    {
        path: 'shop',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () =>
            import('modules/shop/shop-routing.module').then((m) => m.ShopRoutingModule),
    },
    {
        path: 'tables',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () =>
            import('modules/tables/tables-routing.module').then((m) => m.TablesRoutingModule),
    },
    {
        path: 'custom-table',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () =>
          import('modules/custom-table/custom-table.module').then(m => m.CustomTableModule)
      },
    {
        path: 'version',
        loadChildren: () =>
            import('modules/app-common/app-common-routing.module').then(
                (m) => m.AppCommonRoutingModule
            ),
    },
    {
        path: 'chat',
        canActivate: platformAccessGuards,
        canMatch: platformAccessGuards,
        data: { allowedPlatformModes: PLATFORM_ROUTE_ACCESS.TENANT_ONLY },
        loadChildren: () =>
            import('modules/chatbox/chatbox-routing.module').then((m) => m.ChatboxRoutingModule),
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/404',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
}),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
